const env = {
  ID: "staging",
  API_URL: "https://staging.api.locq.com",
  WEB_SOCKET_URL: "wss://bztyf9zu95.execute-api.ap-southeast-1.amazonaws.com/staging",
  GOOGLE_MAP_API_KEY: "AIzaSyAIPhiJk9EgZDcwgrfD4n-kATpZzWKVt7w",
  FIREBASE_CONFIG: {
    apiKey: "AIzaSyB3WjG2l37kK9T2GqJIXoiIsti7Vn_fCHU",
    authDomain: "stocq-test.firebaseapp.com", // Optional, but recommended
    databaseURL: "https://stocq-test-default-rtdb.asia-southeast1.firebasedatabase.app",
    projectId: "stocq-test",
    storageBucket: "stocq-test.firebasestorage.app",
    messagingSenderId: "798509458367",
    appId: "1:798509458367:android:e0c11721b2b87a4f68770a",
  },
  APP_FIREBASE_CONFIG: {
    apiKey: "AIzaSyAgbfBt_Lz0C8EwjxrNI9J-vtfPib6BvHw",
    authDomain: "pivot-seaoil-ap-test.firebaseapp.com",
    databaseURL: "https://pivot-seaoil-ap-test.firebaseio.com",
    projectId: "pivot-seaoil-ap-test",
    storageBucket: "pivot-seaoil-ap-test.appspot.com",
    messagingSenderId: "836556693696",
    appId: "1:836556693696:web:0e82436e0ffdea48720d25",
    measurementId: "G-QVN8590QCX",
    name: "mobile",
  },
};

export default env;
